import type {
  XopQuoteEffectiveStatus,
  XopQuoteListResponse,
  XopQuoteRequestInput,
  XopQuoteResponse,
} from "@xop-any-time/shared";

import { api } from "./api.js";

/**
 * XOP Networks' quotes to this reseller.
 *
 * A FILE OF ITS OWN, not another block in `crmApi.ts`, because these are the
 * only calls in the portal where the reseller is the CUSTOMER rather than the
 * supplier. Keeping them apart means nobody reaches for `listDocuments` when
 * they meant `listXopQuotes` — the mistake that made the old Quotes page
 * confusing in the first place.
 */

/** The list filter. `all` is the default and is NOT sent on the wire. */
export type XopQuoteFilter = XopQuoteEffectiveStatus | "all";

export const xopQuoteKeys = {
  list: (filter: XopQuoteFilter) => ["xop-quotes", filter] as const,
  detail: (id: number) => ["xop-quote", id] as const,
};

export const listXopQuotes = (filter: XopQuoteFilter): Promise<XopQuoteListResponse> =>
  api<XopQuoteListResponse>(
    `/api/crm/xop-quotes${filter === "all" ? "" : `?status=${filter}`}`,
  );

export const getXopQuote = (id: number): Promise<XopQuoteResponse> =>
  api<XopQuoteResponse>(`/api/crm/xop-quotes/${id}`);

export const requestXopQuote = (input: XopQuoteRequestInput): Promise<XopQuoteResponse> =>
  api<XopQuoteResponse>("/api/crm/xop-quotes", { method: "POST", body: input });

export const acceptXopQuote = (id: number): Promise<XopQuoteResponse> =>
  api<XopQuoteResponse>(`/api/crm/xop-quotes/${id}/accept`, { method: "POST", body: {} });

/** The note is optional in the contract and in the dialog — a decline with no
 * reason is still a decline, and forcing a sentence would only produce ".". */
export const declineXopQuote = (id: number, note?: string): Promise<XopQuoteResponse> =>
  api<XopQuoteResponse>(`/api/crm/xop-quotes/${id}/decline`, {
    method: "POST",
    body: note && note.trim() !== "" ? { note: note.trim() } : {},
  });
